import React from 'react';
import { Button } from '../ui/button';
import { Edit2, Save, X } from 'lucide-react';

/**
 * Inline editable bio section component
 * Handles bio text editing with character limit
 */
const EditableBio = ({
  user,
  isEditing,
  bioEditText,
  onBioChange,
  onBioSave,
  onBioCancel,
  onBioClick,
  isSaving
}) => {
  const bioCharLimit = 39;
  const bioCharsRemaining = bioCharLimit - bioEditText.length;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-gray-500">Bio</h3>
        {!isEditing && (
          <Button
            size="sm"
            variant="ghost"
            onClick={onBioClick}
            className="text-gray-400 hover:text-purple-600"
          >
            <Edit2 className="h-4 w-4" />
          </Button>
        )}
      </div>

      {isEditing ? (
        <div className="space-y-2">
          <textarea
            value={bioEditText}
            onChange={(e) => {
              if (e.target.value.length <= bioCharLimit) {
                onBioChange(e.target.value);
              }
            }}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
            rows={2}
            maxLength={bioCharLimit}
            placeholder="Tell us about yourself..."
            autoFocus
          />
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">
              {bioCharsRemaining} characters remaining
            </span>
            <div className="flex gap-2">
              <Button
                size="sm"
                onClick={onBioSave}
                disabled={isSaving}
                className="bg-purple-600 hover:bg-purple-700"
              >
                <Save className="h-4 w-4 mr-1" />
                Save
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={onBioCancel}
                disabled={isSaving}
              >
                <X className="h-4 w-4 mr-1" />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-gray-700">
          {user.bio || (
            <span className="text-gray-400 italic">
              No bio yet. Click edit to add one!
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default EditableBio;
